import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { Button } from '../ui/button';

const FAQSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const faqs = [
    {
      question: 'O site será realmente meu?',
      answer: 'Sim! Durante o período da assinatura, o site é totalmente seu e representa o seu negócio online. Como este é um serviço contínuo (que inclui criação, hospedagem, manutenção e melhorias), o site permanece ativo enquanto a assinatura estiver vigente. Caso a assinatura seja cancelada, o site é desativado, assim como acontece com outros serviços digitais por assinatura.',
    },
    {
      question: 'Tem fidelidade ou contrato longo?',
      answer: 'Sim! O período mínimo é de 6 meses, necessário para garantir a criação, estruturação e os primeiros resultados do seu site. Após esse período, o plano passa a ser mensal e você pode cancelar a qualquer momento.',
    },
    {
      question: 'Quanto tempo leva para ficar pronto?',
      answer: 'Em média, entre 5 a 10 dias úteis. O prazo pode variar de acordo com a complexidade e o envio das informações, mas sempre busco entregar o mais rápido possível.',
    },
    {
      question: 'Posso mudar de plano depois?',
      answer: 'Claro! Você pode fazer upgrade ou downgrade a qualquer momento. A mudança entra em vigor no próximo ciclo de pagamento. E as mudanças na sua landing serão realizadas conforme o plano escolhido, sem complicações.',
    },
    {
      question: 'O que acontece se eu cancelar?',
      answer: 'O site permanece ativo até o final do período já pago. Após isso, ele é desativado. Se quiser voltar depois, é possível reativar o serviço normalmente.',
    },
    {
      question: 'Vocês cuidam do domínio também?',
      answer: 'Sim. O custo do domínio já está incluso no valor mensal. Eu gerencio tudo para você, sem complicações. Se preferir, pode usar um domínio que já tenha.',
    },
    {
      question: 'E se eu precisar de mais funcionalidades?',
      answer: 'Podemos conversar! Dependendo da necessidade, posso incluir no plano atual ou fazer um upgrade personalizado. Sou flexível para atender sua demanda.',
    },
    {
      question: 'Tem garantia?',
      answer: 'Sim! Se nos primeiros 7 dias você não ficar satisfeito, devolvo 100% do valor da primeira mensalidade. Sem perguntas, sem burocracia.',
    },
  ];

  return (
    <section ref={ref} className="py-24 bg-white" id="faq">
      <div className="container mx-auto px-6 lg:px-20">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-gray-600">
            Tire suas dúvidas antes de começar
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: 0.1 * index }}
              >
                <AccordionItem
                  value={`item-${index}`}
                  className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-2xl px-6 hover:border-blue-300 transition-all duration-300"
                >
                  <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-blue-600 py-6 text-lg">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 pb-6 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </motion.div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-16 text-center"
        >
          <p className="text-gray-600 mb-4">Ainda tem dúvidas?</p>
          <Button
            onClick={() => {
              const phone = '5521976614158';
              const message = 'Olá Hugo! Tenho algumas dúvidas sobre os planos.';
              window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
            }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 rounded-full font-semibold text-lg hover:scale-105 transition-all"
          >
            Fale comigo no WhatsApp
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
